import React from 'react';
import SelectField from '../../forms/SelectField';
import { toSelectionFormat } from '../../../lib/collection.utils';
import { filter, find } from 'lodash';

const EventPartnerInputs = ({ onInput, data, dependencies, staticData }) => {
    return (
        <React.Fragment>
            <div className="ckp-admin-grid-column">
                <SelectField
                    name="partnerIds"
                    onChange={onInput}
                    value={data.partnerIds}
                    label="Media Partners"
                    multiple={true}
                    items={toSelectionFormat(filter(dependencies.partners, dp => !find(staticData, sd => sd.id === dp.id)))}
                />
            </div>
        </React.Fragment>
    );
};

export default EventPartnerInputs;



// WEBPACK FOOTER //
// ./src/components/admin/lineup/EventPartnerInputs.js